import { RootState } from "src/Store/store";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DrawerTitle from "src/Components/Drawer/DrawerTitle";
import PinIcon from "src/assets/images/Pin.png";
import DropdownIcon from "src/assets/images/dropdownIcon.png";
import DiagnosticProductImg from "src/assets/images/diagnostric-product-img.png";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import HairCleaner from "src/assets/images/DummyImages/Hair_Cleaner.png";
import BellIcon from "src/assets/images/website-images/bell.png";
import DoorIcon from "src/assets/images/website-images/door.png";
import MobileIcon from "src/assets/images/website-images/mobileIcon.png";
import UserIcon from "src/assets/images/website-images/UserIcon.png";
import ArrowIcon from "src/assets/images/website-images/ArrowIcon.png";
import EditIcon from "src/assets/images/website-images/Group 20102.png";
import OrderDetailsBox from "./OrderDetailsBox";
import SimpleInput from "src/Components/SimpleInput";
import {
  CURRENCY,
  EXPRESS_DELIVERY_CHARGE,
  ImageBaseUrl,
  NewInputUiStyles,
  STANDARD_DELIVERY_CHARGE,
} from "src/lib/constans";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import { AppDispatch } from "src/Store/store";
import { clearSelectedProducts } from "src/Store/cartSlice";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import { removeItemFromCart, setCartItems } from "src/Store/Cart";
import { capitalize } from "@mui/material";

interface IProps {
  onBack: () => void;
  setCheckout: (checkout: boolean) => void;
  deliveryType: "instant delivery" | "express delivery";
  setDeliveryType: (type: "instant delivery" | "express delivery") => void;
  orderData?: {
    products: any[];
    totalPrice: number;
    paymentMethodId: string;
    selectedProductIds: string[];
  };
  acTab: "pharmacy" | "diagnostic";
  confirmOrder?: () => void;
  show: boolean;
  deliveryInstructions:
    | "avoid ringing"
    | "leave at the door"
    | "avoid calling"
    | "leave with the security";
  setDeliveryInstructions: (
    type:
      | "avoid ringing"
      | "leave at the door"
      | "avoid calling"
      | "leave with the security"
  ) => void;
  onError?: () => void;
}

const stripePromise = loadStripe(process.env.REACT_APP_VITE_STRIPE_PK || "");

const ManageCheckout: React.FC<IProps> = ({
  onBack,
  setCheckout,
  deliveryType,
  setDeliveryType,
  orderData,
  acTab,
  confirmOrder,
  show,
  deliveryInstructions,
  setDeliveryInstructions,
  onError,
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const { cartItems } = useSelector((store: RootState) => store.cart);
  const { address } = useSelector((store: RootState) => store.cartSlice);
  const [details, setDetails] = useState<{
    firstName: string;
    lastName: string;
    gender: string;
    mobile: string;
  }>({
    firstName: "",
    lastName: "",
    gender: "",
    mobile: "",
  });
  const [isLoader, setIsLoader] = useState<boolean>(false);
  // const [checkRedeemed, setCheckRedeemed] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();
  const [returnPolicy, setReturnPolicy] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);

  useEffect(() => {
    if (typeof address === "object") {
      setDetails({
        firstName: address?.personName || "",
        lastName: address?.personName || "",
        gender: userDetails?.gender || "male",
        mobile: address?.mobileNumber || "",
      });
    }
  }, [address]);

  const DeliveryType = [
    {
      title: `Instant Delivery | ${EXPRESS_DELIVERY_CHARGE} ${CURRENCY}`,
      buttonText: `${CURRENCY} ${EXPRESS_DELIVERY_CHARGE}`,
      time: "Get it in 30 mins",
      buttonTextColor: "bg-[#DC2626]",
      type: "instant delivery",
      onClick: () => {
        setDeliveryType("instant delivery");
      },
    },
    {
      title: "Express Delivery",
      buttonText: "FREE",
      time: "Earliest Slot 6PM - 7PM",
      buttonTextColor: "bg-[#00B061]",
      type: "express delivery",
      onClick: () => {
        setDeliveryType("express delivery");
      },
    },
  ];

  const DeliveryInstructions = [
    {
      text: "Avoid",
      title2: "ringing bell",
      icon: BellIcon,
      type: "avoid ringing",
    },
    {
      text: "Leave at the",
      title2: "door",
      icon: DoorIcon,
      type: "leave at the door",
    },
    {
      text: "Avoid",
      title2: "calling",
      icon: MobileIcon,
      type: "avoid calling",
    },
    {
      text: "Leave with",
      title2: "the security",
      icon: UserIcon,
      type: "leave with the security",
    },
  ];

  const handleConfirmPayment = async () => {
    if (!orderData?.selectedProductIds.length) {
      toast("No products selected for checkout.", { type: "error" });
      return;
    }

    if (!orderData?.paymentMethodId) {
      toast("No payment method provided. Please add a payment method.", {
        type: "error",
      });
      return;
    }

    setIsLoader(true);
    console.log(orderData, "orderData");
    console.log(cartItems, "gkuygkuygkuygkugkjgkjhkj");
    console.log(acTab, "acTab");
    console.log(
      orderData?.products?.map((v) => ({
        productId: v?._id,
        quantity: acTab === "pharmacy" ? v?.selectedQuantity || 1 : 1,
        itemType:
          acTab === "pharmacy"
            ? v?.itemType
            : cartItems.find((dp) => dp.productId === v?._id)?.type ||
              "product",
      })),
      "ITems DATa"
    );

    const paymentIntentResponse = await httpRequest<{
      clientSecret: string;
      paymentIntentId: string;
    }>({
      method: "post",
      path: `/stripe/create-${
        acTab === "diagnostic" ? "diagnostic" : "pharma"
      }-payment-intent`,
      params: {
        currency: CURRENCY,
        amount:
          orderData?.totalPrice +
          (deliveryType === "instant delivery"
            ? EXPRESS_DELIVERY_CHARGE
            : STANDARD_DELIVERY_CHARGE),
        products: orderData?.products?.map((v) => ({
          productId: v?._id,
          quantity: acTab === "pharmacy" ? v?.selectedQuantity || 1 : 1,
          itemType:
            acTab === "pharmacy"
              ? v?.itemType
              : cartItems.find((dp) => dp.productId === v?._id)?.type ||
                "product",
        })),
      },
    });

    if (paymentIntentResponse.err) {
      toast(paymentIntentResponse.err, { type: "error" });
      setIsLoader(false);
      return;
    }

    const paymentIntentId: string =
      paymentIntentResponse?.res?.paymentIntentId || "";
    const clientSecret: string = paymentIntentResponse?.res?.clientSecret || "";
    const stripe = await stripePromise;

    if (!stripe) {
      toast("Stripe is not initialized. Please try again.", { type: "error" });
      setIsLoader(false);
      return;
    }

    const { paymentIntent, error: confirmError } =
      await stripe.confirmCardPayment(clientSecret, {
        payment_method: orderData?.paymentMethodId, // Use the passed paymentMethodId
      });

    // console.log("paymentIntent", paymentIntent);
    // console.log("confirmError", confirmError);

    if (confirmError) {
      toast(confirmError.message, { type: "error" });
      setIsLoader(false);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      const formData = new FormData();
      if (acTab === "diagnostic") {
        const obj = {
          items: orderData?.products?.map((v) => ({
            _id: v._id,
            itemType:
              cartItems.find((dp) => dp.productId === v?._id)?.type ||
              "product",
          })),
          name: details?.lastName || "",
          gender: userDetails?.gender,
          mobile: details?.mobile,
          // checkRedeemed: checkRedeemed,
          // shippingAddress:
          //   typeof address === "string"
          //     ? address
          //     : address?.streetAddress || "",
          totalAmount:
            orderData?.totalPrice +
            (deliveryType === "instant delivery"
              ? EXPRESS_DELIVERY_CHARGE
              : STANDARD_DELIVERY_CHARGE),
          email: userDetails?.email,
          paymentIntentId: paymentIntentId,
          // redeemedPoints: 0,
          // deliveryInstruction: deliveryInstructions,
          note: returnPolicy,
          // deliveryType: deliveryType,
          addressDetail: address,
        };
        formData.append("diagnosticOrder", JSON.stringify(obj));
      } else {
        formData.append("paymentIntentId", paymentIntentId);
        formData.append(
          "totalAmount",
          String(
            orderData?.totalPrice +
              (deliveryType === "instant delivery"
                ? EXPRESS_DELIVERY_CHARGE
                : STANDARD_DELIVERY_CHARGE)
          )
        );
        formData.append("redeemedPoints", String(0));
        // formData.append("checkRedeemed", String(checkRedeemed));
        formData.append(
          "shippingAddress",
          typeof address === "string" ? address : address?.streetAddress || ""
        );
        formData.append(
          "items",
          JSON.stringify(
            orderData?.products?.map((v) => ({
              _id: v._id,
              quantity: v?.selectedQuantity || 1,
              itemType: v?.itemType,
            }))
          )
        );
        formData.append("name", details?.lastName || "");
        formData.append("gender", details?.gender || "");
        formData.append("mobile", details?.mobile || "");
        formData.append(
          "address",
          typeof address === "string" ? address : address?.streetAddress || ""
        );
        formData.append("customerId", userDetails?._id || "");
        formData.append("firstName", details?.firstName || "");
        formData.append("email", userDetails?.email || "");
        formData.append("deliveryType", deliveryType || "");
        formData.append("deliveryInstruction", deliveryInstructions || "");
        formData.append("note", returnPolicy || "");
        formData.append("addressDetail", JSON.stringify(address));
      }

      const payStatus = await httpRequest<{
        creditPoints: number;
        aedValue: number;
      }>({
        method: "post",
        path: `/${
          acTab === "diagnostic"
            ? "diagnostic-order/create"
            : "pharma-order/create-order"
        }`,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });

      if (payStatus.err) {
        toast(payStatus?.err?.message || payStatus.err, { type: "error" });
        setIsLoader(false);
      } else {
        console.log(payStatus, "payStatus");
        confirmOrder?.();
        dispatch(removeItemFromCart(orderData?.selectedProductIds));

        setIsLoader(false);
      }
    } else {
      toast("Payment failed. Please try again.", { type: "error" });
      onError?.();
      setIsLoader(false);
    }
  };

  return (
    <div className={`w-full ${!show && "hidden"}`}>
      <DrawerTitle title="Checkout" backBtn onBack={onBack} />
      <div className="2xl:p-4 p-2.5 2xl:space-y-4 space-y-2">
        <p className="text-[#2F2F31] font-Poppins-Medium font-size-18px">
          Your Order{" "}
          <span
            className={"text-[#2F2F31] font-Poppins-Regular font-size-16px"}
          >
            - (Shipment)
          </span>
        </p>
        <div className="w-full bg-white box-design overflow-hidden">
          <div className="flex items-center rounded-md 2xl:p-4 p-2.5 justify-start border w-full border-[#E4E4E4]">
            <div className="flex items-center">
              {orderData?.products
                .slice(0, 4)
                ?.map((product: any, index: number) => (
                  <img
                    key={product._id}
                    src={product.image ? product.image : HairCleaner}
                    alt={product.name}
                    className={`w-[51px] h-[50px] object-contain rounded box-design z-[1] ${
                      index === 0 ? "ml-0" : "-ml-4"
                    }`}
                  />
                ))}
            </div>
            <div>
              <p className="text-[#2E4DB4] font-Poppins-Medium font-size-16px pl-6">
                Shipment | {orderData?.products?.length} Item
                {orderData?.products?.length && orderData?.products?.length > 1
                  ? "s"
                  : ""}
              </p>
            </div>
          </div>
          {acTab === "pharmacy" && (
            <div className="grid grid-cols-2 2xl:gap-3 gap-1.5 2xl:p-3 p-2.5">
              {DeliveryType.map((item, i) => (
                <div
                  className={`w-full box-design flex flex-col justify-between bg-white cursor-pointer border ${
                    deliveryType === item.type
                      ? "border-[#00B061] !bg-[#F0FDF4]"
                      : "border-transparent"
                  }`}
                  onClick={item.onClick}
                  id={`delivery-type-${convertToKebabCase(item.type)}`}
                >
                  <div className="2xl:p-1.5 p-1 ">
                    <p className="text-[#202020] font-Poppins-Regular font-size-17px 2xl:pl-2 pt-1">
                      {item.title}
                    </p>
                    <p className="font-Poppins-Medium text-[#3C549A] font-size-17px 2xl:pb-1 pb-0.5 2xl:pl-2">
                      {item.time}
                    </p>
                  </div>
                  <div className="p-2 2xl:p-3 border-t border-[#E6E6E6]">
                    <span
                      className={`font-size-12px text-white 2xl:px-3 px-2 2xl:py-2 py-1.5 rounded-[50px] font-Lexend-Regular ${item.buttonTextColor}`}
                    >
                      {item.buttonText}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {acTab === "pharmacy" && (
          <div className="w-full bg-white box-design 2xl:p-3 p-2">
            <p className="text-[#2F2F31] font-Poppins-Medium font-size-18px 2xl:mb-3 mb-2">
              Delivery Instructions
            </p>
            <div className="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 2xl:gap-2 gap-1.5">
              {DeliveryInstructions.map((item, i) => (
                <div
                  key={i}
                  className={`border p-2 h-full aspect-square 2xl:rounded-[10px] rounded-md text-center flex flex-col items-center justify-center gap-1 cursor-pointer ${
                    deliveryInstructions === item.type
                      ? "border-[#22C55E] bg-[#F0FDF4]"
                      : ""
                  }`}
                  onClick={() =>
                    setDeliveryInstructions(
                      item.type as
                        | "avoid ringing"
                        | "leave at the door"
                        | "avoid calling"
                        | "leave with the security"
                    )
                  }
                  id={`delivery-instruction-${convertToKebabCase(item.type)}`}
                >
                  <img
                    src={item.icon}
                    alt="icon"
                    className="w-7 h-7 object-contain"
                  />
                  <div className="flex flex-col mt-1">
                    <span className="text-[#202020] font-Poppins-Regular font-size-15px">
                      {item.text}
                    </span>
                    <span className="text-[#202020] font-Poppins-Regular font-size-15px">
                      {item.title2}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="bg-white 2xl:p-3 p-2.5 box-design">
          <div className="flex flex-col 2xl:gap-1 gap-0.5 2xl:mb-2 mb-1">
            <div className="flex items-start 2xl:gap-4 gap-2 2xl:mb-3 mb-2 border-b border-[#E6E6E6] 2xl:pb-4 pb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#FEE2E2] 2xl:rounded-[10px] rounded-md mt-1">
                <img
                  src={ArrowIcon}
                  alt="arrow_icon"
                  className="text-[#F04B4B] w-[60%]"
                />
              </div>
              <div className="flex flex-col">
                <p className="text-[#2F2F31] font-Poppins-Medium font-size-17px">
                  Return Policy
                  {/* {acTab === "pharmacy" ? "Return Policy" : "Refund Policy"} */}
                </p>
                <p className="text-[#5B5B5B] font-Poppins-Regular font-size-15px">
                  Order once placed cannot be return
                  {/* {acTab === "pharmacy"
                    ? "Order once placed cannot be return"
                    : "Order once placed cannot be refunded"} */}
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="!w-8 !h-8 flex items-center justify-center bg-[#DBEAFE] 2xl:rounded-[10px] rounded-md">
              <img
                src={EditIcon}
                alt="edit_icon"
                className="text-[#4387F6] w-[60%]"
              />
            </div>

            <div className="flex-1">
              {returnPolicy && !isEdit ? (
                <p className="text-[#2F2F31] font-Poppins-Regular break-all font-size-15px">
                  {returnPolicy}
                </p>
              ) : (
                <SimpleInput
                  value={inputValue}
                  onChange={(value) => setInputValue(value)}
                  placeholder={isEdit ? "Edit Note" : "Add Note"}
                  extraStyle={{ marginBottom: 0 }}
                  id="return-policy-input"
                  newUi
                  maxLength={80}
                />
              )}
            </div>

            <button
              className="w-8 h-8 bg-[#00B061] text-white text-xl rounded-full flex items-center justify-center"
              onClick={() => {
                if (returnPolicy && !isEdit) {
                  setInputValue(returnPolicy);
                  setIsEdit(true);
                } else {
                  if (inputValue.trim()) {
                    setReturnPolicy(inputValue);
                    setInputValue("");
                    setIsEdit(false);
                  }
                }
              }}
              id="return-policy-edit-button"
            >
              <FontAwesomeIcon
                icon={returnPolicy && !isEdit ? faEdit : faPlus}
                size="xs"
              />
            </button>
          </div>
        </div>
        <OrderDetailsBox
          orderTotal={orderData?.totalPrice}
          shipping={
            deliveryType === "instant delivery"
              ? EXPRESS_DELIVERY_CHARGE
              : STANDARD_DELIVERY_CHARGE
          }
          isPharma={acTab === "pharmacy" ? true : false}
        />
        <div className="h-[50px]"></div>
        <div className="absolute bottom-0 left-0 w-full bg-white shadow-[0px_-1px_12px_#00000029] 2xl:p-3 p-2 2xl:h-[60px] h-[50px] flex items-center gap-3">
          <p className="font-size-18px font-Poppins-SemiBold text-[#2F2F31]">
            {CURRENCY}:{" "}
            {(
              (orderData?.totalPrice || 0) +
              (deliveryType === "instant delivery"
                ? EXPRESS_DELIVERY_CHARGE
                : STANDARD_DELIVERY_CHARGE)
            ).toFixed(2)}
          </p>
          <div className="flex-1">
            <GradientBtn
              ButtonText={"Confirm"}
              loader={isLoader}
              type="button"
              btnExtraStyle={{ width: "100%" }}
              onPress={handleConfirmPayment}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageCheckout;
